<div class="modal-header">
    <h3 class="modal-title">Editar Ficha</h3>
    <button type="button" class="close" aria-label="Close" (click)="modal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<form #form="ngForm">
    <div class="modal-body">
        <div class="form-row">
            <div class="form-group col-md-4">
                <label for="dni">Rut</label>
                <input type="text" class="form-control" id="dni" name="dni" disabled="true"
                    [(ngModel)]="trabajador.rut">
            </div>
            <div class="form-group col-md-4">
                <label for="name">Nmbre</label>
                <input type="text" class="form-control" id="name" name="name" [(ngModel)]="trabajador.nombre">
            </div>
            <div class="form-group col-md-4">
                <label for="name">Apellido</label>
                <input type="text" class="form-control" id="lastName" name="lastName" [(ngModel)]="trabajador.paterno">
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="d-flex">
            <button [disabled]="form.invalid" class="btn btn-primary justify-content-end" type="submit"
                (click)="save()">Guardar</button>
        </div>
    </div>
</form>